var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviousArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 5,
    height: 8,
    viewBox: "0 0 7.031 13.321",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-previous"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M.889-2.228l.483.565,5.222,6.1L7.92,3.3,3.18-2.228,7.92-7.759,6.594-8.889l-5.222,6.1Z",
    transform: "translate(-0.889 8.889)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-0.889 8.889)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0.889 -8.889)",
    clipPath: "url(#clip-path-previous)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M19.571-13.889V16.084H-4.111V-13.889Z",
    transform: "translate(-4.214 5.563)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousArrow);
export default __webpack_public_path__ + "static/media/previous-arrow.7909d86d043cad8eaad2cc528a7ab999.svg";
export { ForwardRef as ReactComponent };